module.exports = __webpack_public_path__ + "static/img/contant_1.ad40df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_7/contant_1.jpg
// module id = BHqx
// module chunks = 0